import React from "react";
import styles from "./index.module.css";
import dashboardImage from "../../assets/dashboard.webp";

const OnlineDashboardIntroSection = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.innerDiv}>
        <div className={styles.leftDiv}>
          <img
            className={styles.img}
            src={dashboardImage}
            alt=""
            loading="lazy"
          />
        </div>
        <div className={styles.rightDiv}>
          <div className={styles.infoDiv}>
            <div className={styles.titleDiv}>A Dashboard Without Limits</div>
            <img
              className={styles.imgMob}
              src={dashboardImage}
              alt=""
              loading="lazy"
            />
            <div className={styles.descriptionDiv}>
              <p>
                Access it online anytime, anywhere, and keep every branch
                connected in one place. From monitoring performance to managing
                operations, handle it all with just a few clicks. Stay in
                control, simplify workflows, and focus on growth—not on
                switching between systems.
              </p>
              <p>
                Smart, simple, and powerful. Track performance, streamline
                workflows, and make faster decisions with intuitive tools
                designed for all users. From daily transactions to advanced
                analytics, the dashboard adapts to your needs so you can focus
                on what truly matters: growing your business and serving your
                customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlineDashboardIntroSection;
